import React from "react";
import styled from "@emotion/styled";
import { breakpointMobileExtended } from "src/design-system/styles/breakpoints";
import i18n from "src/locales";
import { compassColors } from "src/utils/styling";
import { isCountry, isMantle, isUSMantle } from "src/utils/userSegment";
import {
  fontLargeHeadline,
  fontSmallHeadline,
  headline,
} from "src/design-system/styles/fonts";

export const Line = styled.p`
  ${headline};
  font-weight: normal;
  font-size: 45px;
  line-height: 50px;
  margin-bottom: 0;
  margin-top: 0;
  letter-spacing: 0.2px;

  @media ${breakpointMobileExtended} {
    ${fontLargeHeadline};
    text-align: center;
  }

  @media only screen and (max-width: 360px) {
    font-size: 24px;
  }
`;

export const SmallLine = styled.p`
  color: ${compassColors.black};
  font-family: "Untitled Serif", sans-serif;
  font-size: 35px;
  line-height: 1.29;
  margin-bottom: 0;
  margin-top: 0.3em;
  margin-right: 1.5em;

  @media ${breakpointMobileExtended} {
    ${fontSmallHeadline};
    letter-spacing: 0.2px;
    text-align: center;
    margin-left: 1.5em;
  }

  @media only screen and (min-width: 721px) and (max-height: 850px) {
    margin-top: 0;
  }
`;

export function Headline() {
  if (isUSMantle()) {
    return <Line>{i18n.t("introv3:headline")}</Line>;
  }

  if (isCountry(["AU", "CA"])) {
    return (
      <>
        <Line>{i18n.t("introv3:headline")}</Line>
        {isCountry(["AU"]) && <SmallLine>{i18n.t("introv3:line4")}</SmallLine>}
      </>
    );
  }

  if (isMantle()) {
    return (
      <>
        <Line>{i18n.t("introv3:line3")}</Line>
        <SmallLine>{i18n.t("introv3:line4")}</SmallLine>
      </>
    );
  }

  return <Line>{i18n.t("introv3:line1")}</Line>;
}
